export default {
  'auth.general.error': 'Oops! Something went wrong!',
};
